import './WifiSelection.css';

import React from 'react';
import { type WifiNetwork } from '@lib/networkApiTypes';
import { Refresh } from '@src/assets';
import { useWifiNetworks } from '@src/contexts';
import { messageBox } from '@src/style/style';
import { WifiNetworkCard } from './WifiNetworkCard';

interface WifiSelectionProps {
  onSkipWifiSelection: () => void
  onWifiSelected: (selectedWifi: WifiNetwork) => void
}

export const WifiSelection = ({ onSkipWifiSelection, onWifiSelected }: WifiSelectionProps): JSX.Element => {
  const { connectedWifiNetwork, wifiNetworks, fetchNetworks, isFetchingNetworks } = useWifiNetworks();
  const wifiNetworksToDisplay = showConnectedWifiFirst(wifiNetworks, connectedWifiNetwork);

  const refreshNetworks = (): void => {
    messageBox('Scanning available WiFi networks...', 'info');
    fetchNetworks();
  };

  return (
    <div id="wifi_selection">
      <div id="wifi_selection_title">Select Your Wi-Fi Network</div>
      <div id="wifi_selection_refresh" onClick={refreshNetworks}>
        <Refresh id="wifi_selection_refresh_icon" className={isFetchingNetworks ? 'spin' : ''} />
        <div>Refresh Networks</div>
      </div>
      <div id="wifi_selection_wifi_list" className="scrollbar">
        {wifiNetworksToDisplay.map(wifiNetwork => (
          <WifiNetworkCard
            key={wifiNetwork.ssid}
            wifiNetwork={wifiNetwork}
            isConnected={wifiNetwork.ssid === connectedWifiNetwork?.ssid}
            onClick={() => { onWifiSelected(wifiNetwork); }}
          />
        ))}
      </div>
      <div id="wifi_selection_skip" onClick={onSkipWifiSelection}>{connectedWifiNetwork === undefined ? 'Do this later' : 'Continue'}</div>
    </div>
  );
};

/**
 * Returns a new list of wifi networks with the connected wifi first, if any.
 */
function showConnectedWifiFirst (wifiNetworks: WifiNetwork[], connectedWifiNetwork?: WifiNetwork): WifiNetwork[] {
  const sortedWifiNetwork: WifiNetwork[] = [];

  if (connectedWifiNetwork !== undefined) {
    sortedWifiNetwork.push(connectedWifiNetwork);
  }

  sortedWifiNetwork.push(...wifiNetworks.filter(wifiNetwork => wifiNetwork.ssid !== connectedWifiNetwork?.ssid));

  return sortedWifiNetwork;
}
